export enum DeviceTypeEnum {
	MOBILE = 'mobile',
	TABLET = 'tablet',
	DESKTOP = 'desktop'
}

export enum DeviceOrientationEnum {
	PORTRAIT = 'portrait',
	LANDSCAPE = 'landscape'
}

export enum CustomBreakpointsEnum {
	MOBILE_MAX_WIDTH = 768,
	TABLET_MAX_WIDTH = 1024
}

export enum BootstrapBreakpointIdentifierEnum {
	SM = 'sm',
	MD = 'md',
	LG = 'lg',
	XL = 'xl'
}
